module.exports = __webpack_public_path__ + "static/media/Tyranitar_Mega.6368a1ec.gif";